/** Resolve institute owner id from API (nested object or legacy numeric user field). */
export const getInstituteOwnerId = (institute) => {
  if (!institute?.user) return null;
  if (typeof institute.user === 'object' && institute.user.id != null) {
    return institute.user.id;
  }
  return institute.user;
};

/** Creator, Django staff/superuser, or platform admin/moderator may edit/delete. */
export const canManageInstitute = (user, institute) => {
  if (!user || !institute) return false;
  if (user.is_superuser || user.is_staff) return true;
  if (['admin', 'moderator'].includes(user.role)) return true;
  const ownerId = getInstituteOwnerId(institute);
  return ownerId != null && String(ownerId) === String(user.id);
};

export const getInstituteSocietyName = (institute) => {
  if (!institute?.society) return null;
  if (typeof institute.society === 'object' && institute.society.name) {
    return institute.society.name;
  }
  return null;
};
